import ItemVatDeterminer from "@/module/Form/VatDeterminer/ItemVatDeterminer";

export default class NonVatPayerItemVatStrategy implements ItemVatDeterminer {
  determinateItemVat(): number {
    return 0.0;
  }
}
